import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { DEFAULT_IMG_PATH } from './file-upload-constant';
import { Subscription } from 'rxjs';
import { SeaculumAngularFormlyService } from '../../services/saeculum-angular-formly.service';
import { INFO_ICON } from '../../constant/common.constant';
import { FormBaseClass } from '../shared/base-class/form-base-class';


@Component({
    selector: 'saeculum-input-file-uploader',
    templateUrl: './file-uploader.component.html',
    styleUrls: ['./file-uploader.component.scss']
})
export class FileUploaderComponent extends FormBaseClass implements OnInit {
    @ViewChild('fileInput', { read: true, static: false }) fileInput: ElementRef;

    @Input() fieldObj: any;
    @Input() options;
    @Input() values;

    @Input() form: FormGroup;
    @Output() valueChange = new EventEmitter<any>();
    imagePreview;
    defaultIcon = this.sanitizer.bypassSecurityTrustResourceUrl(DEFAULT_IMG_PATH.Path);
    infoIcon = INFO_ICON.icon;

    constructor(
        public sanitizer: DomSanitizer,
        private cd: ChangeDetectorRef) {
        super();
    }

    ngOnInit() {
        this.addControl();
    }

    addControl() {
        this.form.addControl(this.fieldObj.key, new FormControl(''));
        this.setValidations(this.form, this.fieldObj);
    }

    fileChange(event: any) {
        const self = this;
        if (event.target.files && event.target.files[0]) {
            const fileList: FileList = event.target.files;
            const reader = new FileReader();
            reader.readAsDataURL(event.target.files[0]);
            reader.onload = (file: any) => {
                self.imagePreview = self.sanitizer.bypassSecurityTrustResourceUrl(file.target.result);
                this.cd.markForCheck();
            };
        }
        this.resetImgTag();
    }

    notifyChange() {
        if (this.form && this.fieldObj.key && this.form.controls[this.fieldObj.key].value) {
            this.valueChange.emit({ key: this.fieldObj.key, value: this.form.controls[this.fieldObj.key].value });
        }
    }

    resetImage() {
        this.imagePreview = null;
        this.resetImgTag();
    }

    resetImgTag() {
        if (this.fileInput) {
            this.fileInput.nativeElement.value = '';
        }
    }

}
